<div class="tag" [class.tag--empty]="isHide">
  <div class="tag__wrap">
    <span>
      <ng-content></ng-content>
    </span>
    <span class="divider"></span>
    <button class="tag__delete-value" (click)="handleOnClick($event)">
      <int-icon size="100%" name="close"></int-icon>
    </button>
  </div>
</div>
